import loadable from '../../../utilities/loadable'

export const ComposerRoot = loadable(() => import('./ComposerRoot'))
